<template lang="pug">
ev-autocomplete(
  v-model="inputValue"
  v-bind="$attrs"
  label="Направленность"
  item-text="name"
  item-value="id"
  :items="$options.constants.EVENT_DIRECTIONS"
)
</template>

<script>
import { EVENT_DIRECTIONS } from '@/modules/Events/constants';

export default {
  constants: {
    EVENT_DIRECTIONS,
  },
  props: {
    value: {
      type: [Number, Object],
      default: null,
    },
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>
